/**
 * KuCoin Exchange Metadata
 */

import { KUCOIN_WS_CHANNELS, KUCOIN_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const KUCOIN_METADATA = {
  id: 'kucoin' as ExchangeId,
  restDocs: [
    'https://www.kucoin.com/docs-new/rest/spot-trading/market-data/get-all-symbols',
    'https://www.kucoin.com/docs-new/rest/spot-trading/market-data/get-klines',
    'https://www.kucoin.com/docs-new/rest/spot-trading/market-data/get-part-orderbook',
    'https://www.kucoin.com/docs-new/rest/spot-trading/market-data/get-trade-history',
  ],
  wsDocs: [
    'https://www.kucoin.com/docs-new/websocket-api/base-info/introduction',
    'https://www.kucoin.com/docs-new/websocket-api/base-info/get-public-token-spot-margin',
  ],
  wsTopology: KUCOIN_WS_TOPOLOGY,
  wsChannels: KUCOIN_WS_CHANNELS,
  notes: [
    'Acquire a bullet token before opening the WebSocket; emit ping frames about every 25 seconds.',
    'Level2 channel publishes deltas only, so resync via REST whenever sequence gaps are detected.',
    'Token-based authentication required for WebSocket connections.',
    'Symbol format: uppercase dash (BTC-USDT).',
  ],
} as const;
